import { render } from "./Paso6PlacaComponent.vue?vue&type=template&id=f6a76ce4"
import script from "./Paso6PlacaComponent.vue?vue&type=script&lang=js"
export * from "./Paso6PlacaComponent.vue?vue&type=script&lang=js"

import "./Paso6PlacaComponent.vue?vue&type=style&index=0&id=f6a76ce4&lang=css"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__